import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-dialog',
  templateUrl: './edit-dialog.component.html',
  styleUrls: ['./edit-dialog.component.scss']
})
export class EditDialogComponent implements OnInit, AfterViewInit, AfterContentChecked {

  fieldName = '';
  placeholderText = '';
  inputText = '';


  editFormGroup = new FormGroup({
    note: new FormControl('', [Validators.required, Validators.maxLength(150)]),
  });

  constructor(
    public dialogRef: MatDialogRef<EditDialogComponent>,
    private changeDedectionRef: ChangeDetectorRef,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public info: any) {
  }

  ngOnInit() {
    this.fieldName = this.info.field;
    this.inputText = this.info.inputText;
    this.placeholderText = this.translateService.instant('PAGES.PRODUCTS.EDIT') + ' ' + this.info.field
  }



  ngAfterViewInit() {
    setTimeout(() => {
      this.editFormGroup = new FormGroup({
        note: new FormControl(this.inputText, [Validators.required, Validators.maxLength(150)]),
      });
    }, 100);

  }

  ngAfterContentChecked(): void {
    this.changeDedectionRef.detectChanges();
  }

  onKeyUp(event: any) {
    const inputValue = event.target.value;
    const isSpecialCharacter = /[ `,.]/;
    const lastChar = inputValue.charAt(inputValue.length - 1);
    if (lastChar === ' ' && isSpecialCharacter.test(inputValue.charAt(inputValue.length - 2))) {
      event.target.value = inputValue.slice(0, -2).trim();
    } else if (lastChar === ' ') {
      event.target.value = inputValue.slice(0, -1) + ', ';
    }
  }

  onKeyDown(event: any) {
    const isSpecialCharacter = /[ `,.]/;
    if (isSpecialCharacter.test(event.key) && event.key !== ' ') {
      event.preventDefault();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmClick(): void {
    this.dialogRef.close({
      element: this.info.element,
      field: this.fieldName,
      textValue: this.fieldName === 'engravement' ? this.editFormGroup.get('note')?.value?.replace(', ', ',').trim() : this.editFormGroup.get('note')?.value
    });
  }

  checkAvailability() {
    if (this.editFormGroup) {
      return !(this.inputText !== this.editFormGroup.get('note')?.value);
    }
    return true;
  }

  getSubtitleText() {
    if (this.fieldName === 'engravement') {
      return this.translateService.instant("PAGES.MANAGEMENT.ENGRAVEMENT_AVAILABILITY");
    }
    return this.fieldName;
  }
}
